import { Calendar, User, ArrowRight } from 'lucide-react';
import { ImageWithFallback } from './figma/ImageWithFallback';
import newsData from '../../data/news.json';

interface NewsItem {
  id: number;
  title: string;
  date: string;
  author: string;
  image: string;
  excerpt: string;
  category: string;
}

const newsItems: NewsItem[] = newsData;

export function News() {
  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl mb-4">Latest News</h1>
          <p className="text-xl text-gray-600">
            Stay updated with our latest announcements and industry insights
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {newsItems.map((item) => (
            <article
              key={item.id}
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow"
            >
              <div className="relative h-56">
                <ImageWithFallback
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <span className="absolute top-4 left-4 bg-primary text-primary-foreground px-3 py-1 rounded-full text-sm">
                  {item.category}
                </span>
              </div>
              <div className="p-6">
                <h3 className="text-xl mb-3 line-clamp-2">{item.title}</h3>
                <div className="flex items-center gap-4 text-sm text-gray-600 mb-4">
                  <span className="flex items-center gap-1">
                    <Calendar size={16} />
                    {item.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <User size={16} />
                    {item.author}
                  </span>
                </div>
                <p className="text-gray-700 mb-4 line-clamp-3">{item.excerpt}</p>
                <button className="text-primary hover:text-primary/80 flex items-center gap-2">
                  Read More
                  <ArrowRight size={16} />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
